import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/services.js";

export function useServices(options = {}) {
  return useQuery({
    queryKey: keys.services.list,
    queryFn: api.fetchServices,
    ...options,
  });
}

export function useCreateService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createService,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.services.all }),
  });
}

export function useUpdateService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateService(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.services.all }),
  });
}

export function useDeleteService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteService,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.services.all }),
  });
}
